export enum loadConfigAction {
  request = '@CONFIG/LOAD_REQUEST',
  success = '@CONFIG/LOAD_SUCCESS',
  failed = '@CONFIG/LOAD_FAILED',
}

export const tipoAcessoAction = '@CONFIG/SET_TIPO_ACESSO';

export const loadConfigRequest = () => ({
  type: loadConfigAction.request,
});
export const loadConfigSuccess = (loadedConfig: ConfigState) => ({
  type: loadConfigAction.success,
  payload: loadedConfig,
});
export const setTipoAcesso = (tipoAcesso: number) => ({
  type: tipoAcessoAction,
  payload: tipoAcesso,
});
